(function () {
  function setupOffer(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var dialog = root.querySelector('[data-iv-offer-dialog]');
    var closeButtons = root.querySelectorAll('[data-iv-offer-close]');
    var delay = Math.max(0, Number(root.dataset.delay || 12000));
    var storageKey = 'iv-offer-seen-v2';
    var previousFocus = null;

    function seen() {
      try { return window.sessionStorage.getItem(storageKey) === '1'; }
      catch (error) { return false; }
    }

    function markSeen() {
      try { window.sessionStorage.setItem(storageKey, '1'); }
      catch (error) {}
    }

    function open() {
      if (seen()) return;
      previousFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      markSeen();
      var first = root.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }

    closeButtons.forEach(function (button) { button.addEventListener('click', close); });
    root.addEventListener('click', function (event) { if (event.target === root) close(); });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab' || root.hidden) return;
      var focusable = Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    if (dialog && !seen()) window.setTimeout(open, delay);
  }

  function setupReviews(root) {
    (root || document).querySelectorAll('.iv-testimonials').forEach(function (section) {
      if (section.dataset.reviewsReady === 'true') return;
      section.dataset.reviewsReady = 'true';

      var modal = section.querySelector('[data-iv-review-modal]');
      var image = section.querySelector('[data-iv-review-image]');
      var closeButton = section.querySelector('[data-iv-review-close]');
      var previousFocus = null;
      if (!modal || !image) return;

      function close() {
        modal.hidden = true;
        image.removeAttribute('src');
        document.documentElement.style.overflow = '';
        if (previousFocus) previousFocus.focus();
      }

      section.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-iv-review-open]');
        if (trigger) {
          previousFocus = trigger;
          image.src = trigger.dataset.ivReviewOpen;
          modal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          closeButton.focus();
          return;
        }
        if (event.target === modal || event.target === closeButton) close();
      });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-iv-offer]').forEach(setupOffer);
    setupReviews(scope || document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
